// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d557ecda","337":"0b44f8ba","453":"611966e5","455":"1bc165d7"}[chunkId] + ".chunk.js";
};